import { ReactElement } from 'react'
import styled from 'styled-components'
import { filledLoteSegments, formatPercent, LOTE_SEGMENTS } from '../format'
import { colors, fontScope, radius } from '../tokens'

const Wrapper = styled.span`
  ${fontScope}
  display: inline-flex;
  align-items: center;
  gap: 6px;
`

const Segments = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 2px;
`

const Segment = styled.span<{ $filled: boolean }>`
  width: 14px;
  height: 4px;
  border-radius: ${radius.segment};
  background: ${({ $filled }) => ($filled ? colors.positive : colors.border)};
`

const Percent = styled.span`
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  color: ${colors.ink500};
  white-space: nowrap;
`

interface LoteBadgeProps {
  percentage: number | null
}

export function LoteBadge({ percentage }: LoteBadgeProps): ReactElement | null {
  if (percentage == null) return null
  const filled = filledLoteSegments(percentage)
  const text = formatPercent(percentage)
  return (
    <Wrapper role="img" aria-label={`${text} da capacidade emitida`}>
      <Segments aria-hidden="true">
        {Array.from({ length: LOTE_SEGMENTS }, (_, index) => (
          <Segment key={index} $filled={index < filled} data-testid={index < filled ? 'lote-segment-filled' : 'lote-segment-empty'} />
        ))}
      </Segments>
      <Percent aria-hidden="true">{text}</Percent>
    </Wrapper>
  )
}
